import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Brands from "./pages/Brands";
import Warranty from "./pages/Warranty";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import NotFoundPage from "./pages/NotFoundPage";
import WarrantyVerify from "./pages/WarrantyVerify";

// Admin imports
import LoginPage from "./admin/pages/LoginPage";
import AdminApp from "./admin/AdminApp";
import PublicAIChat from "./components/ai/PublicAIChat";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* ===== SECRET ADMIN ENTRY POINT ===== */}
        {/* Only users who know this URL can access the admin login */}
        <Route path="/ktec-gate-access" element={<LoginPage />} />

        {/* ===== PROTECTED ADMIN PORTAL ===== */}
        {/* All admin sub-routes are handled inside AdminApp */}
        <Route path="/admin/*" element={<AdminApp />} />

        {/* ===== PUBLIC WEBSITE ROUTES ===== */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/warranty" element={<Warranty />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          {/* Public Warranty Verification */}
          <Route path="/warranty/verify/:warrantyId" element={<WarrantyVerify />} />
          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
      {/* AI Floating Chat — only on public pages (not admin) */}
      <PublicAIChat />
    </>
  );
}

export default App;
